import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FiUserCheck } from 'react-icons/fi';
import { BiError } from 'react-icons/bi';
import { BsClipboardCheck } from 'react-icons/bs';
import { Link } from 'react-router-dom';

import styles from "./ModalComponent.module.css";

export default function ModalComponent({
  isOpen,
  onClose,
  mensagem,
  icon,
  link,
  recarregar
}) {
  const [IconComp, setIconComp] = useState(null);

  useEffect(() => {
    switch (icon) {
      case 'Sucesso':
        setIconComp(<FiUserCheck size="80" className={styles.icon} />);
        break;
      case 'Erro':
        setIconComp(<BiError size="80" className={styles.icon} />);
        break;
      case 'SucessoEnvioQuestionario':
        setIconComp(<BsClipboardCheck size="80" className={styles.icon} />);
        break;
      default:
        setIconComp(null);
    }
  }, [icon]);

  const handleContinue = () => {
    onClose();
    if (recarregar) window.location.reload();
  };

  return (
    <Modal centered isOpen={isOpen}>
      <ModalHeader />
      <ModalBody>
        <div className={styles.icon}>{IconComp}</div>
        <div className={styles.divText}>{mensagem}</div>
      </ModalBody>
      <ModalFooter>
        {link ? (
          <Link to={`/${link}`}>
            <Button size="sm" onClick={handleContinue} className={styles.button}>
              Continuar
            </Button>
          </Link>
        ) : (
          <Button size="sm" onClick={handleContinue} className={styles.button}>
            Continuar
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}
